import { FormField, FormFieldNameEnum, FormFieldType } from "@/types/form";

export const loginPhoneFormFields: FormField[] = [
  { field: FormFieldNameEnum.PhoneNumber, type: FormFieldType.Tel },
];
